import React, { useEffect, useMemo, useState } from 'react';
import { Card, Table, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { buildOverdueColumns, fetchOverdueProposals, ProposalSummaryRow } from './overdueShared';
import dayjs from 'dayjs';

const { Text } = Typography;

const ManualFollowProposalsList: React.FC = () => {
  const navigate = useNavigate();
  const [proposals, setProposals] = useState<ProposalSummaryRow[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const columns = useMemo(() => buildOverdueColumns(navigate), [navigate]);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const endDate = dayjs().subtract(51, 'day').format('YYYY-MM-DD');
        const list = await fetchOverdueProposals({ statusId: 12, daysToAdd: 61, endDate });
        setProposals(list);
      } catch (error) {
        console.error('Manual follow proposals fetch failed', error);
        setProposals([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  return (
    <Card
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>Manuel Takip Süresi Sona Erecek Teklifler (51 Gün+)</span>
          <Text type="secondary">
            <strong>({proposals.length})</strong> kayıt listelendi
          </Text>
        </div>
      }
    >
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={proposals}
        pagination={false}
        rowKey={(record) => record.id}
        size="small"
        scroll={{ x: true }}
        locale={{ emptyText: 'Kayıt bulunamadı' }}
      />
    </Card>
  );
};

export default ManualFollowProposalsList;
